// The QA and prod builds are the same deployed artifact (built once in CI and
// promoted to both environments), so environment-specific config can't be
// selected at build time. Instead we bake in values for every environment and
// pick the right one at runtime based on the hostname the app is served from.
export function isQAHost(): boolean {
  const hostname = window.location.hostname;
  return hostname.split(".")[0] === "qa" || hostname === "localhost";
}

export function getApiUrl(): string {
  const qa = isQAHost();
  return (qa ? import.meta.env.VITE_API_URL_QA : import.meta.env.VITE_API_URL_PROD) || "";
}

export function getFeatureFlagUrl(): string | undefined {
  return import.meta.env.VITE_FF_URL || undefined;
}

export function getFeatureFlagKey(): string | undefined {
  const qa = isQAHost();
  return (qa ? import.meta.env.VITE_FF_KEY_QA : import.meta.env.VITE_FF_KEY) || undefined;
}

export function getGoogleClientId(): string | undefined {
  const qa = isQAHost();
  return (
    (qa ? import.meta.env.VITE_GOOGLE_CLIENT_ID_QA : import.meta.env.VITE_GOOGLE_CLIENT_ID_PROD) ||
    undefined
  );
}
